import Form from 'mobx-react-form';
import { FormField } from 'components/shared/form';
import { ExpenseComp } from 'types/underwriting/income-approach/expenses';

export const comparableExpenseFormFields: FormField[] = [
  {
    name: 'incomeApproach',
    fields: [
      {
        name: 'expenses',
        fields: [
          { name: 'expenseComps', type: 'array', value: [] },
          { name: 'expenseCategories', type: 'array', value: [] },
        ],
      },
    ],
  },
];

export const comparableExpenseFormHelpers = {
  addExpenseComp: (form: Form, comp: ExpenseComp) => {
    form.$('incomeApproach.expenses.expenseComps').add([comp]);
  },
  removeExpenseComp: (form: Form, index: number) => {
    const compsField = form.$('incomeApproach.expenses.expenseComps');
    const comps = compsField.value || [];

    const lastIndex = comps.length - 1;

    const newComps = comps.filter((_: Record<string, any>, i: number) => i !== index);

    compsField.set(newComps);
    compsField.del(lastIndex);
  },
};
